import { useMemo } from "react";
import { EventEmitter } from "events";

const globalEventEmitter = new EventEmitter();

const useEventEmitter = () => {
  const eventEmitter = useMemo(() => globalEventEmitter, []);

  const emitEvent = (eventName: string, data?: any) => {
    eventEmitter.emit(eventName, data);
  };

  const onEvent = (eventName: string, callback: (data?: any) => void) => {
    eventEmitter.on(eventName, callback);
  };

  const offEvent = (eventName: string, callback: (data?: any) => void) => {
    eventEmitter.off(eventName, callback);
  };

  return { emitEvent, onEvent, offEvent };
};

export default useEventEmitter;
